/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { EmailOtpScreen } from "./otp-screen";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { SignUpScreen } from "./signup-screen";
import { getDarkModeStyle } from "../util";

export const SignUp = () => {
  const { currentScreen = "signUp" } = useSelector((state) => get(state, ["login", "signUp"], {}));
  const mode = getDarkModeStyle();

  switch (currentScreen) {
    case "signUp":
      return <SignUpScreen mode={mode} />;
    case "otp":
      return <EmailOtpScreen mode={mode} />;
  }
};
